module.exports = __webpack_public_path__ + "img/6866600c7df7dbe8100ee56c38ccb1e6.svg";